// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1735":"b94f5d4fc5d1b507","1869":"5ada48d989b88f14"}[chunkId] + ".css";
};